import logo from './logo.svg';
import './App.css';
import Nav from './components/Nav.js';
import MainContent from './components/maincontent.js';
import RoomService from './components/RoomService';

import { BrowserRouter as Router, Route, Routes} from "react-router-dom";
// import ".fonts/calibre-Regular.ttf";

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<MainContent/>}></Route>
        <Route path='/RoomService' element={<RoomService/>}></Route>
      {/*
      <MainContent /> */}
      </Routes>
      </Router>
  );
}

export default App;
